export default __webpack_public_path__ + "static/media/logo-exeltis-small.d50d7cee.svg";